module.exports = __webpack_public_path__ + "img/7bed047.jpg";